import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./App.css";
import Router from "./router";

function App() {
  return <Router />;
}

export default App;
